import { mutatorAction } from "satcheljs";
import { shiftRequestStore } from "../";

// TODO deepLink: Remove 'setDeepLinkRequestLoaded' as we're not using it anymore.
export default mutatorAction('SET_DEEP_LINK_REQUEST_LOADED', function setDeepLinkRequestLoaded(isDataLoaded: boolean) {
    shiftRequestStore().deepLinkRequestLoaded = isDataLoaded;
});
